import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@core/environments/environment';
import { DocKyc } from '@core/models/admin/account';
import { AdminManagementService } from '@core/services/admin-management.service';
import { KycAccordionComponent } from '@shared/ui/kyc-accordion/kyc-accordion.component';
import { Subscription } from 'rxjs';

interface IDocTitle {
  [key: string]: string;
}

const DocumentTitle: IDocTitle = {
  signature: 'Signature',
  passport_photograph: 'Passport Photograph',
  means_of_id: 'Means of Identification',
  utility_bill: 'Utility Bill',
};
@Component({
  selector: 'app-ind-documents',
  standalone: true,
  imports: [KycAccordionComponent, CommonModule],
  templateUrl: './ind-documents.component.html',
  styleUrl: './ind-documents.component.scss',
})
export class IndDocumentsComponent {

  @Input() kycDocuments!: DocKyc[];
  @Input() profileId!: string;
  isKycComplete: boolean = false;
  DocumentTitle = DocumentTitle;
  passportImage: string = '';
  subs: Subscription[] = [];

  activatedRoute = inject(ActivatedRoute)
  adminService = inject(AdminManagementService);
  change = inject(ChangeDetectorRef);

  openDocument(link: string) {
    window.open(`${environment.FILE_BASE_URL}${link}`, '_blank');
  }

  ngOnInit(): void {
    this.checkKycStatus();
    this.getPassportImageBlob();
  }

  private checkKycStatus(): void {
    // Check if there are no KYC documents or if the KYC documents array is empty
    if (!this.kycDocuments || this.kycDocuments.length === 0) {
      this.isKycComplete = false;
      return;
    }
  
    // Check if there is at least one approved general KYC document
    const hasApprovedGeneralKyc = this.kycDocuments.some(
      doc => doc.document_type === 'general_kyc' && doc.status === 'approved'
    );
  
    // Determine if KYC is complete
    this.isKycComplete = hasApprovedGeneralKyc || (
      // Check if there are 4 or more documents and all are approved
      this.kycDocuments.length >= 4 &&
      this.kycDocuments.every(doc => doc.status === 'approved')
    );
  }

  getPassportImageBlob(): void {
    const sub = this.adminService.getBVNPassportBlob(this.profileId).subscribe({
      next: (res) => {
        if (res.passport?.image) {
            // Convert the base64 string to a data URL
        this.passportImage = `data:image/jpeg;base64,${res.passport.image}`;
        this.change.detectChanges();
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
    this.subs.push(sub);
  }

  openPassportImage(): void {
    if (this.passportImage) {
      // Open in new tab
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${this.passportImage}" style="max-width: 100%; height: auto;">`);
      }
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
  
}
